/** @format */
import { Response } from './types';

const UNKNOWN_ERROR = '未知错误，请重试';

const errMsg = [
	['401', '请重新登录'],
	['404', '该接口不存在'],
];
/**
 * 返回兼容的错误提示信息
 * @param res response.data
 */
export const getErrorMsg = (
	res: Response = {
		code: 0,
		message: '',
		msg: '',
		errorMsg: '',
	},
) => {
	const { code = 0, message = '', msg = '', errorMsg = '' } = res;
	const errItem = errMsg.find((i) => i[0] === `${code}`) || [];
	const error = errItem[1] || message || msg || errorMsg || UNKNOWN_ERROR;
	return error;
};
